export default "__VITE_ASSET__BEpUJhfL__"